import React from "react";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import ListAltIcon from '@material-ui/icons/ListAlt';
import { getLocalizedString } from "@icarius-localization/strings";

const TextContainer = ({ children }) => {
  return (
    <span style={{ fontWeight: 100, fontSize: 18 }}>
      {children}
    </span>
  )
}

const IconContainer = ({ children }) => {
  return (
    <span style={{ display: 'flex', justifyContent: 'center' }}>
      {children}
    </span>
  )
}

export const getStatusText = (key, usesMedalPoints) => {
  return {
    E: (
      <TextContainer>
        {getLocalizedString("statusE1")}
        <br />
        <br />
        {getLocalizedString("statusE2")}
        <br />
        <br />
        {getLocalizedString("statusE3")}
        <br />
        <br />
        {getLocalizedString("statusE4")}
        <br />
        <br />
        {getLocalizedString("statusE5")}
        <br />
        <br />
        <IconContainer>
          <CustomIconButton
            title={getLocalizedString("sendMessage")}
            type={'mail'}
          />
        </IconContainer>
        <br />
        {getLocalizedString("statusE6")}
        <br />
        {getLocalizedString("statusE7")}
      </TextContainer>
    ),
    F: (
      <TextContainer>
        {getLocalizedString("statusF1")}
        <br />
        <br />
        <IconContainer>
          <CustomIconButton title={getLocalizedString("progressControl")}>
            <ListAltIcon />
          </CustomIconButton>
        </IconContainer>
        <br />
        {getLocalizedString("statusF2")}
        <br />
        <br />
        {getLocalizedString("statusF3")}
        <br />
        <br />
        <IconContainer>
          <CustomIconButton
            title={getLocalizedString("sendMessage")}
            type={'mail'}
          />
        </IconContainer>
        <br />
        {getLocalizedString("statusF4")}
        <br />
        <br />
        {getLocalizedString("statusF5")}
        <br />
        {getLocalizedString("statusF6")}
        <br />
        <br />
        {getLocalizedString("statusF7")}
        <br />
        {getLocalizedString("statusF8")}
      </TextContainer>
    ),
    B: (
      <TextContainer>
        {getLocalizedString("statusB1")}
        <br />
        <br />
        {getLocalizedString("statusB2")}
        <br />
        <br />
        {getLocalizedString("statusB3")}
        <br />
        <br />
        {getLocalizedString("statusB4")}
        <br />
        {getLocalizedString("statusB5")}
      </TextContainer>
    ),
    K: (
      <TextContainer>
        {getLocalizedString("statusK1")}
        <br />
        <br />
        {getLocalizedString("statusK2")}
        <br />
        <br />
        {getLocalizedString("statusK3")}
        <br />
        <br />
        {getLocalizedString("statusK4")}
        <br />
        <br />
        <IconContainer>
          <CustomIconButton
            title={getLocalizedString("sendMessage")}
            type={'mail'}
          />
        </IconContainer>
        <br />
        {getLocalizedString("statusK5")}
        <br />
        {getLocalizedString("statusK6")}
      </TextContainer>
    ),
    T: (
      <TextContainer>
        {getLocalizedString("statusT1")}
        <br />
        <br />
        {getLocalizedString("statusT2")}
        <br />
        {getLocalizedString("statusT3")}
      </TextContainer>
    ),
    R: (
      <TextContainer>
        {getLocalizedString("statusR1")}
        <br />
        <br />
        {getLocalizedString("statusR2")}
        <br />
        <br />
        {
          usesMedalPoints &&
          <>
            {getLocalizedString("statusR2a")}
            <br />
            <br />
          </>
        }
        {getLocalizedString("statusR3")}
      </TextContainer>
    ),
  }[key];
}